import React from 'react';
import { SectionTitle } from './SectionTitle';
import { stepTags, steps } from '../../data/artTherapy';
export function FourSteps() {
  return <section aria-labelledby="steps-title" className="bg-cream py-14 md:py-20" data-id="element-94" data-mp="654ws78wd2n7">
      <div className="mx-auto max-w-5xl px-5" data-id="element-95" data-mp="kszr1s2jzf2e">
        <SectionTitle id="steps-title" subtitle="Válassz egyet a több mint 150 tevékenység közül, készíts elő néhány egyszerű eszközt, és kövesd lépésről lépésre az utasításokat." data-id="element-96" data-mp="fv7zx09qfwz9">
          A feszültségtől a nagyobb nyugalomig, mindössze 4 egyszerű lépésben
        </SectionTitle>

        <ol className="mt-8 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4" data-id="element-97" data-mp="3je1bx8mv4drb">
          {steps.map((s, i) => <li key={s.title} className="flex flex-col items-center rounded-3xl border border-lavender-line bg-white px-3 py-6 text-center sm:px-5" data-id="element-98" data-mp="147hc2f9umpe" data-mpi={i}>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lavender-line font-display text-lg font-bold text-ink" data-id="element-99" data-mp="1ckpde1eyinbi">
                {i + 1}
              </span>
              <h3 className="mt-4 font-display text-[16px] font-bold leading-snug text-ink" data-id="element-100" data-mp="szkszz5f7mqm">{s.title}</h3>
              
            </li>)}
        </ol>

        <ul className="mx-auto mt-5 flex max-w-lg flex-wrap justify-center gap-3" data-id="element-101" data-mp="xwb8ak9eieaz">
          {stepTags.map(t => <li key={t} className="rounded-full border border-lavender-line bg-[#F4EFF6] px-5 py-3 text-[13px] font-extrabold uppercase tracking-[0.08em] text-ink" data-id="element-102" data-mp="11xmxiood4xin">
              {t}
            </li>)}
        </ul>
      </div>
    </section>;
}